document.addEventListener('DOMContentLoaded', function() {
  if (!document.getElementById('external-api-form')) return;

  const formContainer = document.getElementById('after-sales-form-container');
  const formToggleHeader = document.getElementById('form-toggle-header');
  const toggleButton = document.getElementById('toggle-button');
  const form = document.getElementById('external-api-form');
  const chatContainer = document.getElementById('chat-container');
  const chatMessages = document.getElementById('chat-messages');
  const showFormBtn = document.getElementById('show-form-btn');
  const sendMessageBtn = document.getElementById('send-message-btn');
  const chatInput = document.getElementById('chat-input');
  const submitButton = document.getElementById('submit-button');
  const loadingSpinner = document.getElementById('loading-spinner');
  const btnText = submitButton.querySelector('.btn-text');
  const responseDiv = document.getElementById('form-response');

  let selectedFiles = [];
  let currentTicketId = null; // 存储当前工单ID
  let isLoading = false; // 加载状态标识
  let loadingMessageElement = null; // 加载消息元素引用
  let selectedProducts = []; // 存储选中的商品信息

  // 1. 表单collapsed/expand
  formToggleHeader.addEventListener('click', function() {
    formContainer.classList.toggle('collapsed');
    const isCollapsed = formContainer.classList.contains('collapsed');
    toggleButton.querySelector('.toggle-text').textContent = isCollapsed ? 'expand' : 'collapsed';
  });

  // 2. 修改申请按钮，显示表单，隐藏聊天
  showFormBtn.addEventListener('click', function() {
    chatContainer.style.display = 'none';
    formContainer.style.display = 'block';
    if(formContainer.classList.contains('collapsed')) {
       formContainer.classList.remove('collapsed');
       toggleButton.querySelector('.toggle-text').textContent = 'collapsed';
    }
  });

  // 3. 二级联动问题分类
  const mainIssueSelect = document.getElementById('main-issue-type');
  const subIssueContainer = document.getElementById('sub-issue-container');
  const subIssueSelects = document.querySelectorAll('.sub-issue-select');
  
  mainIssueSelect.addEventListener('change', function() {
    const selectedValue = this.value;
    subIssueContainer.style.display = 'none';
    subIssueSelects.forEach(select => {
      select.style.display = 'none';
      select.disabled = true;
      select.required = false;
      select.value = '';
    });
    if (selectedValue) {
      const targetSubSelect = document.getElementById(`sub-issue-${selectedValue}`);
      if (targetSubSelect) {
        subIssueContainer.style.display = 'block';
        targetSubSelect.style.display = 'block';
        targetSubSelect.disabled = false;
        targetSubSelect.required = true;
      }
    }
  });

  // 4. 字符计数
  const messageTextarea = document.getElementById('message');
  const charCount = document.getElementById('char-count');
  messageTextarea.addEventListener('input', function() {
    const count = this.value.length;
    charCount.textContent = Math.min(count, 500);
    if (count > 500) {
      this.value = this.value.substring(0, 500);
      charCount.style.color = '#dc3545';
    } else {
      charCount.style.color = '#6c757d';
    }
  });
  
  // 4.5 订单号查询与自动选中
  const orderNumberInput = document.getElementById('order-number-input');
  const fetchOrderBtn = document.getElementById('fetch-order-btn');
  const orderDisplay = document.getElementById('order-display');
  let currentOrderData = null;
  
  // 5. 商品多选功能
  function initProductSelection() {
    // 移除之前的事件监听器，避免重复绑定
    const existingSelectAllHandler = document._selectAllHandler;
    const existingProductSelectHandler = document._productSelectHandler;
    
    if (existingSelectAllHandler) {
      document.removeEventListener('change', existingSelectAllHandler);
    }
    if (existingProductSelectHandler) {
      document.removeEventListener('change', existingProductSelectHandler);
    }
    
    // 全选功能
    const selectAllHandler = function(e) {
      if (e.target.classList.contains('select-all-checkbox')) {
        // 找到当前全选框所在的订单卡片
        const orderCard = e.target.closest('.order-card');
        if (orderCard) {
          // 只选择当前订单卡片内的商品复选框
          const productCheckboxes = orderCard.querySelectorAll('.product-select-checkbox');
          
          productCheckboxes.forEach(checkbox => {
            checkbox.checked = e.target.checked;
            updateProductItemStyle(checkbox);
          });
        }
        
        updateSelectedProducts();
      }
    };
    
    // 单个商品选择
    const productSelectHandler = function(e) {
      if (e.target.classList.contains('product-select-checkbox')) {
        updateProductItemStyle(e.target);
        updateSelectedProducts();
        
        // 检查是否需要更新全选状态
        const orderCard = e.target.closest('.order-card');
        if (orderCard) {
          const orderProductCheckboxes = orderCard.querySelectorAll('.product-select-checkbox');
          const orderSelectAllCheckbox = orderCard.querySelector('.select-all-checkbox');
          
          if (orderSelectAllCheckbox) {
            const checkedCount = Array.from(orderProductCheckboxes).filter(cb => cb.checked).length;
            orderSelectAllCheckbox.checked = checkedCount === orderProductCheckboxes.length;
            orderSelectAllCheckbox.indeterminate = checkedCount > 0 && checkedCount < orderProductCheckboxes.length;
          }
        }
      }
    };
    
    document.addEventListener('change', selectAllHandler);
    document.addEventListener('change', productSelectHandler);
    
    // 保存引用以便后续移除
    document._selectAllHandler = selectAllHandler;
    document._productSelectHandler = productSelectHandler;
  }
  
  function updateProductItemStyle(checkbox) {
    const productItem = checkbox.closest('.product-item');
    if (checkbox.checked) {
      productItem.classList.add('selected');
    } else {
      productItem.classList.remove('selected');
    }
  }
  
  function updateSelectedProducts() {
    selectedProducts = [];
    const checkedBoxes = document.querySelectorAll('.product-select-checkbox:checked');
    
    checkedBoxes.forEach(checkbox => {
      const productItem = checkbox.closest('.product-item');
      if (productItem) {
        selectedProducts.push({
          id: productItem.getAttribute('data-product-id'),
          title: productItem.getAttribute('data-product-title'),
          variant: productItem.getAttribute('data-product-variant'),
          quantity: productItem.getAttribute('data-product-quantity'),
          price: productItem.getAttribute('data-product-price'),
          sku: productItem.getAttribute('data-product-sku') || ''
        });
      }
    });
  }
  
  // 初始化商品选择功能
  initProductSelection();

  function getShopDomain(orderNumber) {
    let shopDomain = 'tataan.myshopify.com';
    if (orderNumber === 'LC897839') {
      shopDomain = '2vnpww-33.myshopify.com';
    }
    return shopDomain;
  }

  if (fetchOrderBtn) {
    fetchOrderBtn.addEventListener('click', async function() {
      const orderNumber = (orderNumberInput?.value || '').trim();
      if (!orderNumber) {
        showError('Please enter orderID');
        return;
      }
      fetchOrderBtn.disabled = true;
      const originalText = fetchOrderBtn.textContent;
      fetchOrderBtn.textContent = 'Querying...';
      orderDisplay.innerHTML = '';
      responseDiv.style.display = 'none';

      try {
        const response = await fetch(`https://jl.jianda.ai/api/orders/number/${encodeURIComponent(orderNumber)}`, {
          headers: {
            'X-Shopify-Shop-Domain': getShopDomain(orderNumber)
          }
        });
        const result = await response.json();
        if (response.ok && result.success) {
          currentOrderData = result.data;
          renderOrder(currentOrderData);
        } else {
          currentOrderData = null;
          throw new Error(result.error?.message || 'Order not found');
        }
      } catch (err) {
        showError(`Query order failed：${err.message}`);
      } finally {
        fetchOrderBtn.disabled = false;
        fetchOrderBtn.textContent = originalText || 'Query order';
      }
    });
  }

  function renderOrder(order) {
    if (!orderDisplay) return;
    const itemHtml = (order.lineItems || [])
      .map((item, index) => `
        <div class="product-item" data-product-id="${item.id || index}" data-product-title="${escapeHtml(item.title)}" data-product-variant="${escapeHtml(item.variantTitle || 'Default Title')}" data-product-quantity="${item.quantity}" data-product-price="${item.price}">
          <div class="product-checkbox">
            <input type="checkbox" class="product-select-checkbox" id="product-${item.id || index}">
          </div>
          <div class="product-image">
            <div class="placeholder-image">📦</div>
          </div>
          <div class="product-info">
            <div class="product-details">
              <div class="product-title-row">
                <h4 class="product-title">${escapeHtml(item.title)}</h4>
              </div>
              <div class="product-specs-row">
                <div class="product-specs">
                  ${item.variantTitle ? `<span class="product-variant">${escapeHtml(item.variantTitle)}</span>` : ''}
                  <span class="quantity-info"> x ${item.quantity}</span>
                </div>
                <div class="product-pricing">
                  <span class="total-price">${item.price}${order.currency ? ' ' + order.currency : ''}</span>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      `) 
      .join('');
    orderDisplay.innerHTML = `
      <div class="order-card selected">
        <div class="order-header">
          <div class="order-meta">
            <h3 class="order-number">Order: ${escapeHtml(order.orderNumber || '')}</h3>
            <div class="order-basic-info">
              <span class="order-date">${order.createdAt ? new Date(order.createdAt).toLocaleString() : '-'}</span>
              <span class="order-total">Total: ${order.totalPrice}${order.currency ? ' ' + order.currency : ''}</span>
            </div>
          </div>
          <div class="order-status">
            <span class="status-badge status-${(order.status || '').toLowerCase().replace(/\s+/g, '-')}">
              ${escapeHtml(order.status || '')}
            </span>
          </div>
        </div>
        <div class="products-header">
          <div class="select-all-products">
            <input type="checkbox" class="select-all-checkbox" id="select-all-dynamic">
            <label for="select-all-dynamic">Select All Products</label>
          </div>
        </div>
        <div class="order-items">${itemHtml}</div>        
      </div>`;
    
    // 重新初始化商品选择功能
    initProductSelection();
  }

  // 5. 图片上传预览及管理
  const imageInput = document.getElementById('images');
  const imagePreview = document.getElementById('image-preview');

  imageInput.addEventListener('change', function() {
    const files = Array.from(this.files);
    if (selectedFiles.length + files.length > 5) {
      alert('You can only upload up to 5 images');
      return;
    }
    files.forEach(file => {
      if (file.size > 5 * 1024 * 1024) {
        alert(`File ${file.name} exceeds 5MB limit`);
        return;
      }
      if (!file.type.startsWith('image/')) {
        alert(`File ${file.name} is not a valid image format`);
        return;
      }
      selectedFiles.push(file);
    });
    updateImagePreview();
    this.value = ''; // 清空选择，以便再次选择相同文件
  });

  imagePreview.addEventListener('click', function(e) {
    if (e.target.classList.contains('remove-image')) {
      const index = parseInt(e.target.getAttribute('data-index'), 10);
      if (!isNaN(index)) {
        selectedFiles.splice(index, 1);
        updateImagePreview();
      }
    }
  });

  function updateImagePreview() {
    imagePreview.innerHTML = '';
    selectedFiles.forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = function(e) {
        const previewItem = document.createElement('div');
        previewItem.className = 'preview-item';
        previewItem.innerHTML = `
          <img src="${e.target.result}" class="preview-image" alt="Preview image">
          <button type="button" class="remove-image" data-index="${index}">×</button>
        `;
        imagePreview.appendChild(previewItem);
      };
      reader.readAsDataURL(file);
    });
  }

  // 6. 表单提交逻辑
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    if (submitButton.disabled) return;
    
    // 清除旧的错误提示
    responseDiv.style.display = 'none';
    responseDiv.textContent = '';
    
    // 执行验证
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // 设置加载状态
    submitButton.disabled = true;
    btnText.textContent = 'Submitting...';
    loadingSpinner.style.display = 'block';

    
    
    // 验证已查询订单
    if (!currentOrderData || !currentOrderData.orderId) {
      showError('Please query and confirm the order first！');
      return;
    }
    
    // 验证是否选择了商品
    updateSelectedProducts(); // 确保获取最新的选中商品
    if (selectedProducts.length === 0) {
      showError('Please select at least one product for after-sales service！');
      return;
    }

    // 验证问题类型
    if (!mainIssueSelect.value) {
      showError('Please select a problem category！');
      return;
    }
    const activeSubSelect = document.querySelector('.sub-issue-select:not(:disabled)');
    if (!activeSubSelect || !activeSubSelect.value) {
      showError('Please select a specific problem！');
      return;
    }

    // 验证描述
    const message = messageTextarea.value.trim();
    if (!message) {
      showError('Please fill in the problem description！');
      return;
    }

    // 禁用按钮，显示加载
    submitButton.disabled = true;
    btnText.textContent = 'Submitting...';
    loadingSpinner.style.display = 'block';
    responseDiv.style.display = 'none';

    

    // 图片处理（示例：转换为Base64字符串数组）
    if (selectedFiles.length > 0) {
      sendData.images = await Promise.all(selectedFiles.map(file => fileToBase64(file)));
    }

    //let selectedProductsStr = '';   

    // 在聊天窗口显示用户发出的申请数据摘要
    let userMessage = `Order：${currentOrderData.orderNumber}\n`;
    userMessage += 'Selected Products\n';
    selectedProducts.forEach(item => {
      const variant = item.variant && item.variant !== 'Default Title' ? ` (${item.variant})` : '';
      userMessage += `- ${item.title}${variant} Qty: ${item.quantity} Price: ${item.price}\n`;
      //selectedProductsStr += `- ${item.title}${variant} Qty: ${item.quantity} Price: ${item.price}\n`;
    });
    userMessage += `Type：${mainIssueSelect.value} - ${activeSubSelect.value}\n`;
    userMessage += `Desc：${message}`;

    // 隐藏表单, 显示聊天窗口
    formContainer.classList.add('collapsed');
    toggleButton.querySelector('.toggle-text').textContent = 'expand';
    chatContainer.style.display = 'flex';

    // 在聊天窗口显示用户消息
    chatMessages.innerHTML = ''; // 清空历史消息
    addMessage(userMessage, 'user');

    // 构造提交数据对象
    const sendData = {
      order_id: currentOrderData.orderId,
      order_number: currentOrderData.orderNumber,
      order_date: currentOrderData.createdAt,
      order_total: currentOrderData.totalPrice,
      //selected_products: selectedProducts, // 包含选中的商品信息
      issue_type_main: mainIssueSelect.value,
      issue_type_sub: activeSubSelect.value,
      user_message: userMessage,
      times: 1,
      customer_id: (window.ShopCustomer && window.ShopCustomer.id != null) ? String(window.ShopCustomer.id) : '8377471238369',
      customer_email: (window.ShopCustomer && window.ShopCustomer.email) ? window.ShopCustomer.email : 'xxx123@126.com',
      images: [] // 图片base64或文件上传处理暂略，这里可根据实际API调整
    };


    let shopDomain = getShopDomain(sendData.order_number);

    try {
      // 真实场景:
      
      const response = await fetch('https://jl.jianda.ai/api/after-sales/submit', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-Shopify-Shop-Domain': shopDomain
        },
        body: JSON.stringify(sendData)
      });
      const result = await response.json();

      if (response.ok) {
        console.log('Submit Success:', result);
        // 存储工单ID
        currentTicketId = result.data.ticketId;
        
        // 显示AI回复内容
        let aiResponse = '';
        if (result.data.response && result.data.response.content) {
          // 处理content可能是对象的情况
          if (typeof result.data.response.content === 'object' && result.data.response.content.output) {
            aiResponse = result.data.response.content.output;
          } else if (typeof result.data.response.content === 'string') {
            aiResponse = result.data.response.content;
          } else {
            aiResponse = JSON.stringify(result.data.response.content);
          }
        } else {
          aiResponse = `Hello, we have received your after-sales application (number: ${result.data.ticketId}).\n\nWe are processing your request, please wait, the customer service representative will contact you soon.`;
        }
        
        addMessage(aiResponse, 'support');
        
        // 如果需要人工审核，显示系统提示
        if (result.data.requiresReview) {
          addMessage('This problem requires human review, we will arrange a dedicated person to handle it as soon as possible.', 'system');
        }
        subIssueContainer.style.display = 'none';
        charCount.textContent = '0';
      } else {
        throw new Error(result.error?.message || 'Submit Failed');
      }
    } catch (error) {
      console.error('Submit Error:', error);
      addMessage(`Sorry, your application submission failed, possibly due to a network issue. Please try again later or contact our online customer service. Error message: ${error.message}`, 'support');
      // 如果失败，让用户可以重新编辑
      formContainer.classList.remove('collapsed'); toggleButton.querySelector('.toggle-text').textContent = 'collapsed';

    } finally {
      // 恢复按钮状态
      submitButton.disabled = false;
      btnText.textContent = 'Submit Application';
      loadingSpinner.style.display = 'none';
    }
  });

  // 7. 聊天功能
  function addMessage(content, sender = 'user') {
    const messageDiv = document.createElement('div');
    messageDiv.classList.add('message', sender);
    
    let avatarText;
    switch(sender) {
      case 'user':
        avatarText = 'Me';
        break;
      case 'support':
        avatarText = 'L';
        break;
      case 'system':
        avatarText = '⚠️';
        break;
      default:
        avatarText = 'L';
    }
    
    let messageContent;
    // 如果是AI回复，使用markdown格式化
    if (sender === 'support' && typeof marked !== 'undefined') {
      const contentDiv = document.createElement('div');
      contentDiv.className = 'markdown-content';
      contentDiv.innerHTML = marked.parse(content);
      messageContent = contentDiv.outerHTML;
    } else {
      messageContent = escapeHtml(content);
    }
    
    messageDiv.innerHTML = `
      <div class="message-avatar">${avatarText}</div>
      <div class="message-content">${messageContent}</div>
    `;
    chatMessages.appendChild(messageDiv);
    chatMessages.scrollTop = chatMessages.scrollHeight;
  }
  
  // 显示加载消息
  function showLoadingMessage() {
    if (loadingMessageElement) return; // 避免重复添加
    
    loadingMessageElement = document.createElement('div');
    loadingMessageElement.className = 'loading-message';
    loadingMessageElement.innerHTML = `
      <div class="loading-spinner"></div>
      <span>AI is thinking...</span>
    `;
    chatMessages.appendChild(loadingMessageElement);
    chatMessages.scrollTop = chatMessages.scrollHeight;
  }
  
  // 隐藏加载消息
  function hideLoadingMessage() {
    if (loadingMessageElement) {
      loadingMessageElement.remove();
      loadingMessageElement = null;
    }
  }
  
  // 设置加载状态
  function setLoadingState(loading) {
    isLoading = loading;
    const submitBtn = document.querySelector('.submit-btn');
    const sendBtn = sendMessageBtn;
    const chatInputField = chatInput;
    
    if (loading) {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }
      if (sendBtn) {
        sendBtn.disabled = true;
      }
      if (chatInputField) {
        chatInputField.disabled = true;
      }
      showLoadingMessage();
    } else {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit';
      }
      if (sendBtn) {
        sendBtn.disabled = false;
      }
      if (chatInputField) {
        chatInputField.disabled = false;
      }
      hideLoadingMessage();
    }
  }
  
  sendMessageBtn.addEventListener('click', async function() {
    const text = chatInput.value.trim();
    if (!text || isLoading) return;
    
    // 检查是否有工单ID
    if (!currentTicketId) {
      addMessage('Please submit an after-sales application first.', 'system');
      return;
    }
    
    // 添加用户消息
    addMessage(text, 'user');
    chatInput.value = '';
    chatInput.style.height = 'auto'; // Reset height
    
    setLoadingState(true); // 开始加载状态
    
    // 发送继续对话请求
    try {
      const response = await fetch('https://jl.jianda.ai/api/after-sales/continue', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Shop-Domain': getShopDomain(currentOrderData?.orderNumber || '')
        },
        body: JSON.stringify({
          ticketId: currentTicketId,
          message: text
        })
      });
      
      const result = await response.json();
      
      if (result.success && result.data.response && result.data.response.content) {
        let aiReply;
        if (typeof result.data.response.content === 'object' && result.data.response.content.output) {
          aiReply = result.data.response.content.output;
        } else if (typeof result.data.response.content === 'string') {
          aiReply = result.data.response.content;
        } else {
          aiReply = JSON.stringify(result.data.response.content);
        }
        addMessage(aiReply, 'support');
        
        // 如果需要人工审核，显示系统提示
        if (result.data.status === 'pending_review') {
          addMessage('This problem requires human review, we will handle it as soon as possible.', 'system');
        }
      } else if (result.data && result.data.status === 'failed') {
        addMessage('This problem has failed, we will handle it as soon as possible.', 'system');
      } else {
        addMessage('This problem has failed, we will handle it as soon as possible.', 'system');
      }
    } catch (error) {
      console.error('Continue conversation error:', error);
      addMessage('Network error, please try again later.', 'system');
    } finally {
      setLoadingState(false); // 结束加载状态
    }
  });

  chatInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessageBtn.click();
    }
  });
  // 自动调整文本框高度
  chatInput.addEventListener('input', function() {
      this.style.height = 'auto';
      this.style.height = (this.scrollHeight) + 'px';
  });

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML.replace(/\n/g, '<br>');
  }

  // 文件转Base64
  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  // 显示错误信息
  function showError(message) {
    submitButton.disabled = false;
    btnText.textContent = 'Submit Application';
    loadingSpinner.style.display = 'none';
    responseDiv.className = 'alert alert-error';
    responseDiv.textContent = message;
    responseDiv.style.display = 'block';
  }
});
